import './index.css';

import { AppToaster } from '@slims-pro/ui/molecules';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './app/router';
import { queryClient } from './lib/query-client';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
			<AppToaster />
		</QueryClientProvider>
	</StrictMode>,
);
